// ---------------------------------------------------------------------------
// themeEquipUpdate — o que gravar em `users/{uid}` quando a pessoa EQUIPA um
// tema. Um lugar só para as três portas (Aparência, barra de teste da Loja e o
// card de evento da Loja).
//
// Existe por causa do tema de EVENTO (Halloween, `config/themeEvents.ts`):
// quando o evento fecha, o resolvedor devolve a pessoa ao tema que ela usava
// ANTES — e esse "antes" só existe se for gravado no instante em que ela
// equipa o tema de evento. Uma porta que esquecesse o campo deixaria quem
// entrou por ela no `default` em 03/11, enquanto quem entrou pelas outras
// volta ao tema de sempre.
// ---------------------------------------------------------------------------

import { THEME_EVENT_OF } from "../../config/themes";
import { isThemeEventOpen } from "../../config/themeEvents";
import type { UpdatableProfile } from "../../services/firebase/userService";

/**
 * @param nextId   tema escolhido.
 * @param equipped tema EQUIPADO agora, já resolvido (`useTheme().equippedTheme`)
 *                 — nunca o do preview da Loja, que a pessoa só está testando.
 */
export function themeEquipUpdate(nextId: string, equipped: string): UpdatableProfile {
  // Trocar de um tema de evento para outro (ou re-equipar o mesmo) NÃO
  // sobrescreve o "antes": ele tem de continuar apontando para o último tema
  // que a pessoa escolheu de verdade, e o resolvedor não volta para evento.
  if (THEME_EVENT_OF[nextId] && !THEME_EVENT_OF[equipped]) {
    return { themePreference: nextId, themeBeforeEvent: equipped };
  }
  return { themePreference: nextId };
}

/**
 * O tema que a lista da Aparência deve marcar como "em uso", a partir dos
 * campos CRUS (a lista não tem os guards todos à mão).
 *
 * Só corrige o caso do evento fechado: `themePreference` continua "halloween"
 * depois de 02/11, mas o que está na tela é o tema de antes.
 */
export function displayedEquippedTheme(
  themePreference: string | null | undefined,
  themeBeforeEvent: string | null | undefined,
  at: Date = new Date(),
): string {
  const pref = themePreference || "default";
  const eventId = THEME_EVENT_OF[pref];
  if (!eventId || isThemeEventOpen(eventId, at)) return pref;
  const before = themeBeforeEvent || "default";
  return THEME_EVENT_OF[before] ? "default" : before;
}
